export default [{
	name:'index',
	path: '/team/index',
	component: resolve => require(['@/views/team/index'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team'
	}
}, {
	path: '/team/fillinfo',
	component: resolve => require(['@/views/team/fillInfo'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/onuser/fillinfo',
	component: resolve => require(['@/views/team/noUserFillInfo'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/record/:tabVal',
	component: resolve => require(['@/views/team/record'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/onuser/record',
	component: resolve => require(['@/views/team/noUserRecord'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		keepAlive: true
	}
}, {
	path: '/team/detail',
	component: resolve => require(['@/views/team/detail'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/confirm',
	component: resolve => require(['@/views/team/confirm'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/success',
	component: resolve => require(['@/views/team/success'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	name:'register',
	path: '/team/register',
	component: resolve => require(['@/views/team/register'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team'
	}
}, {
	path: '/team/retrial',
	component: resolve => require(['@/views/team/retrial'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/change/order/:torder_id',
	component: resolve => require(['@/views/team/changeOrder'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team',
		needLogin: true
	}
}, {
	path: '/team/change/psd/:type',
	component: resolve => require(['@/views/team/changePsd'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'team'
	}
}]


// WEBPACK FOOTER //
// ./src/router/modules/team.js